export var requestConfig = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
};